import axios, { AxiosRequestConfig } from "axios";
import { errorMsg } from "../simpleMessageAlert";

export async function uploadFileViaGcsSignedUrl(
  signedURL: string,
  fileToBeUploaded: File,
  setProgress: (progress: number) => void,
  otherAxiosConfig: AxiosRequestConfig
): Promise<any> {
  const headers = {
    "Content-Type": "application/octet-stream",
  };
  try {
    return await axios.put(signedURL, fileToBeUploaded, {
      headers,
      onUploadProgress: function (progressEvent) {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        setProgress(percentCompleted);
      },
      ...otherAxiosConfig
    });
  } catch (error) {
    errorMsg(error.message);
    throw error;
  }
}
